import $store from '@/store.js'
import Tool from '@/assets/js/utils.js'
const { protocol } = window.location
// 加载serviceList.js并存储全局变量供media及公共header使用   已经调用
function loadSudoku (data, session) {
  window.serviceList = {
    userseviceUrl: `${protocol}//${data.userservice}`,
    session,
    menuInterfaceUrl: `${protocol}//${data.menuListInterfaceUrl}`, // 用于公共头部接口
    shareUrl: `${protocol}//${data.shareServerUrl}`, // 用于header
    mediaApiUrl: `${protocol}//${data.mediaApiUrl}`, // 用于media接口
    mediaServerUrl: `${protocol}//${data.mediaServerUrl}`, // 用于media js
    blobUrl: `${protocol}//${data.blobUrl}`,
    menuServerUrl: `${protocol}//${data.menuServerUrl}`
  }
  // document.write(`<script type="text/javascript" src="${protocol}//${$store.state.common.baseUrl.userservice}/package.serviceList/serviceList.v2.js" ></script>`)
}

// 谷歌分析
function initGoogleAnalytics () {
  ((h, o, t, j, a, r) => {
    a = o.getElementsByTagName('head')[0]
    r = o.createElement('script')
    r.async = 1
    r.src = t + j
    a.appendChild(r)
  })(window, document, 'https://www.googletagmanager.com/gtag/js?id=', 'G-VGMT47K0K3')
  window.dataLayer = window.dataLayer || []

  function gtag () { dataLayer.push(arguments) }

  gtag('js', new Date())
  gtag('config', 'G-VGMT47K0K3')
}
// gtag记录
function initGtag () {
  // Global site tag (gtag.js) - Google Analytics
  ((h, o, t, j, a, r) => {
    a = o.getElementsByTagName('head')[0]
    r = o.createElement('script')
    r.async = 1
    r.src = t + j
    a.appendChild(r)
  })(window, document, 'https://www.googletagmanager.com/gtag/js?id=', 'UA-131320724-24')
  window.dataLayer = window.dataLayer || []

  function gtag () { dataLayer.push(arguments) }

  gtag('js', new Date())
  gtag('config', 'UA-131320724-24')
}

// 加载language的js文件
const loadLanguageJs = () => {
  const jsUrl = 'https://cc-ms.tvunetworks.com/language/langConfig.js'
  document.write(`<script type="text/javascript" src=${jsUrl} ></script>`)
  isCompleteLoad()
  // Tool.dynamicLoadJs(jsUrl, function() {
  //     $store.state.common.hasInitLang = true;
  //     loadHeaderJs();
  // });
}
const isCompleteLoad = () => {
  if (typeof langConfig != 'undefined') {
    $store.state.common.hasInitLang = true
  } else {
    setTimeout(() => {
      isCompleteLoad()
    }, 100)
  }
  initGoogleAnalytics()
  initGtag()
}
// 加载headerConfig
function loadHeaderJs () {
  // let cssUrl = `http://local.tvunetworks.com:8000/headerConfig.min.css`;
  const cssUrl = `${protocol}//${$store.state.common.baseUrl.menuServerUrl}/headerConfig.min.css`
  const jsUrl = `${protocol}//${$store.state.common.baseUrl.menuServerUrl}/headerConfig.js`
  // let jsUrl = `http://local.tvunetworks.com:8000/headerConfig.js`;
  Tool.includeLinkStyle(cssUrl)
  Tool.dynamicLoadJs(jsUrl, () => {
    const timers = setInterval(() => {
      try {
        if (langConfig) {
          // let lang = langConfig.langValue || window.localStorage.getItem('lang') || navigator.language || navigator.userLanguage;
          clearInterval(timers)
          // let session = window.localStorage.getItem('channelSession');
          // window.headerObj = new headerTemplate(lang, session);
        }
      } catch (err) {

      }
    }, 10)
  })
}
// 加载mediaCommon
function loadMediaJs (callback) {
  // 若当前js界面中已存在，则无需加载
  if ($('#mediaCommon').length > 0 && typeof (callback) == 'function') {
    callback()
  } else {
    const url = `${protocol}//${$store.state.common.baseUrl.mediaServerUrl}/js/mediaCommon.js`
    Tool.dynamicLoadJs(url, () => {
      if (typeof (callback) == 'function') {
        callback()
      }
    }, 'mediaCommon')
  }
}
export {
  loadSudoku,
  initGoogleAnalytics,
  initGtag,
  loadMediaJs,
  loadHeaderJs,
  loadLanguageJs
}
